const VentilationInfo = ({codingscreendata,typeOfPatient}) => {
  return (
    <div>
      <div>
        {/* icu, mv, niv */}
        <div className="code-screen-hours-icu-mv" style={{
          marginBottom:`${typeOfPatient == 'outPatient' ? ".8rem": " "}`
        }}>
          <span>
            ICU Hours:{" "}
            <span style={{ color: "#252C32",fontWeight:'normal' }}>
              {codingscreendata?.data?.meta?.icu_hours ?? "None"}
            </span>
          </span>

          <span>
            MV Hours:{" "}
            <span style={{ color: "#252C32",fontWeight:'normal' }}>
              {codingscreendata?.data?.meta?.hours_of_mechanical_ventilation ??
                "None"}
            </span>
          </span>

          {/* <span>NIV Hours: 8</span> */}
        </div>
      </div>
    </div>
  );
};

export default VentilationInfo;
